import axios from 'utils/requestHelper';

const fetchAll = (params) => axios.get('v1/clients/ads', { params });

const AdsAPI = {
  fetchAll,
};

export default AdsAPI;
